import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const ApplicationUserRelationPage = lazy(() => import('../views/list/ApplicationUserRelationPage'));

export function ApplicationUserRelationPageLazy() {
	return (
		<PageSuspense>
			<ApplicationUserRelationPage />
		</PageSuspense>
	);
}
